export default {
    esgPlatform: {
        common: {
            myProducts: "My Products",
            esgCompliance: "ESG Compliance",
            active: "Active",
            deactivated: "Deactivated",
        },

        title: 'ESG Platform',
        esgCompliance: 'ESG Compliance',
        standards: 'Standards',
        addNewStandard: 'Add New Standard',
        standardTitle: 'Standard Title',
        standardTitleTT: 'Enter the title of the standard',
        shortCode: 'Short Code',
        shortCodeTT: 'Enter the short code of the standard',
        standardDescription: 'Standard Description',
        standardDescriptionTT: 'Enter the description of the standard',
        seal: 'Seal',
        sealTT: 'Select the seal of the standard',
        status: 'Status',
        upload: 'Upload',
        thisfieldIsRequired: 'This field is required',
        pleaseFillRequiredFields: 'Please fill the required fields',
        standardAddedSuccessfully: 'Standard added successfully',
        errorSubmittingForm: 'Error submitting form',
        createNewEsgStandard: 'Create New ESG Standard',
        close: 'Close',
        settings: 'Settings',
        next: 'Next',
        keyIssuesAndGoals: 'Key Issues and Goals',
        keyIssuesAndGoalsTT: 'Key issues and goals of the standard',
        environmental: 'Environmental',
        issues: 'Issues',
        addIssue: 'Add Issue',
        social: 'Social',
        governance: 'Governance',
        goals: 'Goals',
        target: 'Target (Year)',
        questions: 'Questions',
        addNewGoal: 'Add New Goal',
        deleteIssueConfirmation: 'Are you sure you want to delete this issue? Deleting this issue will also permanently delete all associated goals and questions. This action cannot be undone.',
        deleteGoalConfirmation: 'Are you sure you want to delete this goal? Deleting this goal will also permanently delete all associated questions. This action cannot be undone.',
        deleteConfirmation: 'Are you sure you want to delete? This action cannot be undone.',
        standardSettings: 'Standard Settings',
        standardStatus: 'Standard Status',
        active: 'Active',
        inactive: 'Inactive',
        approvalMethod: 'Approval Method',
        approveManually: 'Approve Manually',
        scoreForApproval: 'Score for Approval',
        overallProtocolScore: 'Overall Protocol Score',
        overallProtocolScoreTT: 'Enter the overall protocol score',
        environmetalScore: 'Environmental Score',
        environmetalScoreTT: 'Enter the environmental score',
        socialScore: 'Social Score',
        socialScoreTT: 'Enter the social score',
        governanceScore: 'Governance Score',
        governanceScoreTT: 'Enter the governance score',
        mandatoryApproval: 'Mandatory Approval',
        preview: 'Preview',
        pleaseAddAtLeastOneIssueAndGoal: "Please add at least one issue with at least one goal before proceeding to the preview.",
        noContentToPreview: "There is no content to preview. Please add at least one issue and goal.",
        standardPreview: "Standard Preview",
        saveStandard: "Save Standard",
        standardSavedSuccessfully: "Standard saved successfully!",
        standardDeletedSuccessfully: "Standard deleted successfully!",
        protocolDeletedSuccessfully: "Protocol deleted successfully!",
        standardUpdatedSuccessfully: "Standard updated successfully!",
        pleaseEnterWholeNumberBetween0and100: "Please enter percentage between 0 and 100",
        issueCreatedSuccessfully: "Issue created successfully",
        errorCreatingIssue: "Error creating issue. Please try again.",
        issueTitleUpdatedSuccessfully: "Issue title updated successfully",
        errorUpdatingIssueTitle: "Error updating issue title. Please try again.",
        issueDeletedSuccessfully: "Issue deleted successfully",
        errorDeletingIssue: "Error deleting issue. Please try again.",
        goalCreatedSuccessfully: "Goal created successfully",
        errorCreatingGoal: "Error creating goal. Please try again.",
        goalUpdatedSuccessfully: "Goal updated successfully",
        errorUpdatingGoal: "Error updating goal title. Please try again.",
        errorDeletingGoal: "Error deleting goal. Please try again.",
        goalDeletedSuccessfully: "Goal deleted successfully",
        standardActivatedSuccessfully: "Standard activated successfully",
        goalTitleRequired: "Goal title is required",
        questionsRequired: "Questions are required",
        noSurveyAvailable: "No survey available",
        myProducts: {
            addNewProduct: "Add New Product",
            lastUpdated: "Last Updated",
            addedBy: "Added By",
        },
        dashboard: {
            subEnterprises: "Sub-Enterprises",
            registerSubEnterprise: "Register Sub-Enterprise",
            exportAsCSV: "Export as CSV",
            enterprise: "Enterprise",
            licenseID: "License ID",
            membershipPlan: "Membership Plan",
            activationKeys: "Activation Keys",
            users: "Users",
            registrationDate: "Registration Date",
            country: "Country",
            status: "Status",

            countryPlaceholder: "Select country",
            enterpriseName: "Enterprise Name",
            enterpriseNamePlaceholder: "Enter enterprise name",
            enterpriseEmail: "Enterprise Email",
            enterpriseEmailPlaceholder: "Enter email address",
            enterprisePhoneNumber: "Enterprise Phone Number",
            enterprisePhoneNumberPlaceholder: "Enter phone number",
            provincePlaceholder: "Enter province/state",
            regionPlaceholder: "Enter region/district",
            villagePlaceholder: "Enter village/town/city",
            address: "Address",
            province: "Province/State",
            region: "Region/District",
            village: "Village/Town/City",
            addressPlaceholder: "Enter address",
            dateOfRegistration: "Date of Registration",
            dateOfRegistrationPlaceholder: "Select registration date",
            subscriptionUpTo: "Subscription Up To",
            subscriptionUpToPlaceholder: "Select subscription end date",
            products: "Products",
            initialAssessmentReport: "Initial Assessment Report",
            enterHere: "Enter Here",
            attachInitialAssessmentReport: "Attach Initial Assessment Report",
            linkWithProducts: "Link with Products",
            linkWithProductsPlaceholder: "Select linked products",
            uploadLogo: "Upload Logo",
            uploadLogoPlaceholder: "Upload enterprise logo",
            licenseIDPlaceholder: "Enter License ID",

            deactivateAccount: "Deactivate Account",
            activateAccount: "Activate Account",
            deactivateMsg: "Are you sure you want to deactivate this account?",
            activateMsg: "Are you sure you want to activate this account?",
            deleteAccount: "Delete Account",
            deleteMsg: "Are you sure you want to remove this account?",

        },
        
        activate: 'Activate',
        confirmation: 'Confirmation',
        standardDeleteConfirmation: 'Are you sure you want to delete this standard?',
        protocolDeleteConfirmation: 'Are you sure you want to delete this protocol?',
        surveyQuestionForTheGoal: 'Survey Question for the Goal',
        selectExistingESGSurveyOrCreateNew: 'Select existing ESG survey or create new',
        createnewSurvey: 'Create new survey',
        startContinueSurvey: 'Start/Continue Survey',
        surveyOverview: 'Survey Overview',
        surveyTitle: 'Survey Title',
        surveyCompletionPercentage: 'Survey Completion Percentage',
        inProgress: 'In Progress',
        surveyProgress: 'Survey Progress',
        howToCompleteSurvey: 'How to Complete Survey',
        confirmSurveyResponse:"You are about to submit the answer for Farmer(John Miler). Please confirm if you would like to proceed.",
        progress: {
            progress: 'Progress',
            dashboard: 'Dashboard',
            esgProgress: 'ESG Progress',
            companyName: 'Company Name',
            search: 'Search',
            select: 'Select',
            country: 'Country',
            standard: 'Standard',
            subOrganization: 'Sub-Organization',
            protocols: 'Protocols',
            actions: 'Actions',
            subOrganizations: 'Sub-Organizations',
            downloadReport: 'Download Report',
            comparison: 'Comparison',
            messages: 'Messages',
            validateData: 'Validate Data',
            recommendations: 'Recommendations',
            ESRSIssueAndGoals: 'ESRS Issues and Goals',

        },
        startNewEsgProtocol: "Start New ESG Protocol",
        getStartedWithEsg: "Get Started with ESG",
        getStartedEsgMsg: "No protocols have been added yet. Add a protocol to begin your journey toward effective ESG management and reporting.",
        startEsgProtocol: "Start ESG Protocol",
        createNewProtocolWithoutStandard: "Create new protocol without a standard",
        selectEsgStandard: "Select ESG Standard",
        addNewProtocol: "Add New Protocol",
        protocolTitle: "Protocol Title",
        subOrganization: "Sub-Organizations",
        protocolAddedMsg: "Protocol added successfully.",
        existingProtocols: "Existing Protocols",

        protocolSettings: "Protocol Settings",
        protocolSettingsUpdated: "Protocol settings successfully updated.",
        failedToUploadFile: "Failed to upload image. Please try again.",
        failedToUploadFileToS3: "Failed to upload image to s3",

        selectSubOrg: "Select Sub-Organizations",
        selectSubOrgMsg: "Select the sub-organization for which you are setting targets and goals related to ESG (Environmental, Social, and Governance) protocols. This option allows you to specify which part of your organization is responsible for implementing and tracking these objectives. By assigning goals to individual sub-organizations, you can tailor ESG initiatives to address specific operational needs and impacts, ensuring a focused approach to sustainability and governance at different organizational levels.",
        selectedSubOrg: "Selected Sub-Organizations",
        subOrgs: "Sub-Organizations",
        activityLog: "Activity Log",
        activityLogFor: "Activity Log For",
        activityLogDesc: "Track all changes made to ESG goals, questions, and issues, including additions, edits, and deletions, with details on the user, action, and timestamp",
        protocolActivatedSuccessfully: "Protocol activated successfully",

        activationKey: "Activation Key",
        userNameAndId: "User Name & ID",
        email: "Email",
        userRole: "User Role",
        userRegistrationDate: "User Registration Date",
        protocolUpdatedSuccessfully: "Protocol updated successfully.",

        createNewProtocol: "Create new protocol",
        myProtocols: "My Protocols",
        
    },
   
};